<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div class="fill-height">
        <md-table v-model="templates" md-sort="title" md-sort-order="asc" @md-selected="view" md-card md-fixed-header>
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">Message Templates</h1>
            </div>
            <div class="md-toolbar-section-end">
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field md-clearable>
                    <md-input placeholder="Search by name..." v-model="search" @input="doFilter" />
                  </md-field>
                </div>
                <div class="md-layout-item md-size-15" style="text-align: right">
                  <md-button @click="addTemplate" class="md-raised md-primary">Add</md-button>
                </div>
              </div>
            </div>

          </md-table-toolbar>

          <md-table-empty-state
            md-label="No Templates found"
            :md-description="`No templates found for this '${search}' query. Try a different search term or create a new template.`">
            <md-button class="md-primary md-raised" @click="addTemplate">Create New Template</md-button>
          </md-table-empty-state>

          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell md-label="Title" md-sort-by="title">{{ item.title }}</md-table-cell>
            <md-table-cell md-label="Body">{{ item.body }}</md-table-cell>
            <md-table-cell md-label="Trigger">{{item.offset_days | offsetFormat}}</md-table-cell>
          </md-table-row>
        </md-table>
        <TemplateDialog :show="showAddTemplateDialog" @save="createTemplate" @cancel="showAddTemplateDialog = false;"/>
      </div>
    </div>
  </div>
</template>
<script>
import TemplateDialog from '@/components/modals/TemplateDialog.vue'
export default {
  name: "TemplateList",
  components: {
    TemplateDialog
  },
  props: {
    templates: Array,
    detailLink: String
  },
  methods: {
    addTemplate: function() {
      this.showAddTemplateDialog = true
    },
    createTemplate: function(m) {
      this.showAddTemplateDialog = false
      this.$emit("create", m)
    },
    doFilter: function() {
      this.$emit('filter', this.search)
    },
    view: function(template) {
      this.$router.push(`${this.detailLink}/${template.template_id}`)
    },
  },
  data: function() {
    return {
      showFilter: false,
      showAddTemplateDialog: false,
      search: undefined
    }
  },
  filters: {
    offsetFormat: function(value){
      if(value && value > 0) {
        return `${value} day(s) after member start date`
      } else if(value && value < 0) {
        return `${value} day(s) before member start date`
      }else {
        return "On member start date"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fill-height {
  height: calc(100vh - 250px - 68px);
}
</style>
